import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import UAParser from "ua-parser-js";
import { differenceInMinutes, format, formatRelative } from "date-fns";
import { get, isEmpty, set } from "lodash";
import showdown from "showdown";
import mime from "mime-types";
import queryString from "query-string";
import constants from "./constants";
import Store from "./Store";
import { getMessaging, getToken } from "firebase/messaging";
// @ts-ignore
import { v4 as uuidv4 } from "uuid";
import enUS from "date-fns/locale/en-US/index.js";
import { datadogRum } from "@datadog/browser-rum";
import getEnv from "./getEnv";
import { t } from "i18next";
export var getGender = function getGender(value) {
  return constants.GENDERS.find(function (g) {
    return g.value == value;
  });
};
export var getUserAgent = function getUserAgent(providedUserAgent) {
  var parser = new UAParser(providedUserAgent);
  return parser.getResult();
};
export var isIPad = function isIPad() {
  var _navigator, _navigator2, _navigator3;
  var platform = (_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.platform;
  var userAgent = (_navigator2 = navigator) === null || _navigator2 === void 0 ? void 0 : _navigator2.userAgent;
  return (platform === "iPad" || platform === "MacIntel" && ((_navigator3 = navigator) === null || _navigator3 === void 0 ? void 0 : _navigator3.maxTouchPoints) > 1) && /iPad|Macintosh|iPhone|iOS/i.test(userAgent);
};

// True only for mobile phones (excludes tablets and desktops). Uses ua-parser-js
// device.type, which returns "mobile" for phones and "tablet" for tablets.
// Used to restrict phone-only features such as cough-sound recording (PB-358).
export var isMobilePhone = function isMobilePhone(providedUserAgent) {
  if (typeof navigator === "undefined" && !providedUserAgent) return false;
  var _getUserAgent = getUserAgent(providedUserAgent),
    device = _getUserAgent.device;
  return device.type === "mobile";
};
export var isAndroidWebView = function isAndroidWebView() {
  var userAgent = getUserAgent();
  var isAndroidOS = userAgent.os.name === "Android";
  var hasVersion = userAgent.ua.toLowerCase().includes("version");
  return isAndroidOS && hasVersion;
};
export var isIOSWebView = function isIOSWebView() {
  var _userAgent$browser$na;
  var userAgent = getUserAgent();
  var hasSupportedModel = userAgent.device.vendor === "Apple" && (userAgent.device.model === "iPhone" || userAgent.device.model === "iPod" || userAgent.device.model === "iPad");
  var hasSupportedEngine = userAgent.engine.name === "WebKit";
  var isNotBrowser = !((_userAgent$browser$na = userAgent.browser.name) !== null && _userAgent$browser$na !== void 0 && _userAgent$browser$na.includes("Safari"));
  return hasSupportedModel && hasSupportedEngine && isNotBrowser;
};
export var isWebView = function isWebView() {
  return isAndroidWebView() || isIOSWebView();
};
export var getCurrentRegion = function getCurrentRegion() {
  var _window, _getEnv;
  var _split = (_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.host.split(".");
  var region = "global";
  if (_split.length > 1 && (_getEnv = getEnv("NEXT_PUBLIC_REGIONS")) !== null && _getEnv !== void 0 && (_getEnv = _getEnv.split(",")) !== null && _getEnv !== void 0 && _getEnv.includes(_split[0])) {
    region = _split[0];
  }
  return region;
};
export var getPlatform = function getPlatform() {
  if (isAndroidWebView()) {
    return constants.PLATFORMS.ANDROID;
  }
  if (isIOSWebView()) {
    return constants.PLATFORMS.IOS;
  }
  return constants.PLATFORMS.PWA;
};
export var isValidDate = function isValidDate(date) {
  return date instanceof Date && !Number.isNaN(date.getTime());
};
export var getFormattedDate = function getFormattedDate(date) {
  var dateFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "E PP hh:mm a";
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "NA";
  var dateVal = new Date(date);
  return date && isValidDate(dateVal) ? format(dateVal, dateFormat) : defaultValue;
};
export var truncateMiddle = function truncateMiddle(fullStr, strLen, separatorParam) {
  if (isEmpty(fullStr) || fullStr.length <= strLen) {
    return fullStr;
  }
  var separator = separatorParam || "...";
  var sepLen = separator.length;
  var charsToShow = strLen - sepLen;
  var frontChars = Math.ceil(charsToShow / 2);
  var backChars = Math.floor(charsToShow / 2);
  return fullStr.substr(0, frontChars) + separator + fullStr.substr(fullStr.length - backChars);
};
export var getNameInitials = function getNameInitials(name) {
  if (!!name) {
    var nameSplit = name.split(/\s+|_|(?=[A-Z])/);
    var first = get(nameSplit, [0, 0], "");
    var last = get(nameSplit, [1, 0], "");
    return "".concat(first.toUpperCase()).concat(last.toUpperCase());
  }
  return "-";
};
export var convertMarkdownToHtml = function convertMarkdownToHtml(markdownString) {
  var _markdownString;
  var converter = new showdown.Converter({
    simpleLineBreaks: true,
    underline: true,
    tables: true
  });
  markdownString = (_markdownString = markdownString) === null || _markdownString === void 0 ? void 0 : _markdownString.replaceAll("\n", "<br />");
  var htmlString = converter.makeHtml(markdownString);
  return htmlString;
};
export var isDevEnv = function isDevEnv() {
  return getEnv("NODE_ENV") === "development";
};
export var getUrlAuthToken = function getUrlAuthToken() {
  var _window2;
  var params = queryString.parse((_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.location) === null || _window2 === void 0 ? void 0 : _window2.search);
  return get(params, ["url_auth_token"], "");
};
export var getMessageType = function getMessageType(media_uid, studyUid, reportUid, formResponseUid, questionnaire_uid, questionnaire_response_uid) {
  if (media_uid) {
    return constants.MESSAGE_TYPES.MEDIA;
  } else if (studyUid) {
    return constants.MESSAGE_TYPES.STUDY;
  } else if (reportUid) {
    return constants.MESSAGE_TYPES.REPORT;
  } else if (formResponseUid) {
    return constants.MESSAGE_TYPES.FORM;
  } else if (questionnaire_uid) {
    return constants.MESSAGE_TYPES.QUESTION;
  } else if (questionnaire_response_uid) {
    return constants.MESSAGE_TYPES.ANSWER;
  }
  return "";
};
export var getMediaType = function getMediaType(mimeType) {
  var images = constants.IMAGE_TYPES;
  var docs = constants.DOC_TYPES;
  var audios = constants.AUDIO_TYPES;
  var extension = mime.extension(mimeType) || "";
  if (images.includes(extension)) {
    return {
      type: constants.MEDIA_TYPES.IMAGE,
      extension: extension
    };
  } else if (docs.includes(extension)) {
    return {
      type: constants.MEDIA_TYPES.DOCUMENT,
      extension: extension
    };
  } else if (audios.includes(extension)) {
    return {
      type: constants.MEDIA_TYPES.AUDIO,
      extension: extension
    };
  } else {
    return {
      type: constants.MEDIA_TYPES.NA,
      extension: extension
    };
  }
};
export var isNonDicomFile = function isNonDicomFile(fileType) {
  var fileTypes = ["png", "jpg", "jpeg"];
  return fileTypes.some(function (type) {
    var _fileType$toLowerCase;
    return fileType === null || fileType === void 0 || (_fileType$toLowerCase = fileType.toLowerCase()) === null || _fileType$toLowerCase === void 0 ? void 0 : _fileType$toLowerCase.includes(type);
  });
};
export var isValidEmail = function isValidEmail(text) {
  return /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(text);
};

/**
 * Returns true if the given role name (e.g. from userInfo.details.name or workspace role)
 * should be treated as a QC radiologist. Any role whose name contains "qc" (case-insensitive) is considered QC.
 */
export var isQcRadiologistRoleName = function isQcRadiologistRoleName(roleName) {
  var raw = String(roleName !== null && roleName !== void 0 ? roleName : "").toLowerCase().trim();
  if (!raw) return false;
  return raw.includes("qc");
};
var DEMO_SOURCE_ID = ["demo@qure.ai", "demo.qure.ai"];
export var isDemoSource = function isDemoSource(sourceId) {
  return DEMO_SOURCE_ID.includes(sourceId);
};
export var convertBufferToFile = function convertBufferToFile(arrayBuffer, fileName) {
  var blob = new Blob([arrayBuffer], {
    type: "application/octet-stream"
  });
  return new File([blob], fileName ? fileName : "anonymous", {
    type: "application/octet-stream"
  });
};
export var getCookies = function getCookies() {
  var _cookies = document.cookie.split("; ");
  var allCookies = {};
  _cookies.forEach(function (cookie) {
    var _cookie$split = cookie.split("="),
      _cookie$split2 = _slicedToArray(_cookie$split, 2),
      key = _cookie$split2[0],
      val = _cookie$split2[1];
    set(allCookies, [key], val);
  });
  return allCookies;
};
export var generatePatientId = function generatePatientId() {
  var uuidPart = uuidv4().split("-").pop();
  var timePart = Math.floor(Date.now() / 1000).toString(); // Using Date.now() for milliseconds and converting to seconds
  var patientId = (uuidPart + timePart).toUpperCase();
  return patientId;
  // return Math.random().toString(36).slice(2).toUpperCase();
};
export var getFCMToken = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return getToken(getMessaging(), {
            vapidKey: getEnv("NEXT_PUBLIC_VAPID")
          });
        case 1:
          return _context.a(2, _context.v);
      }
    }, _callee);
  }));
  return function getFCMToken() {
    return _ref.apply(this, arguments);
  };
}();
export function getIsOnpremise() {
  try {
    var isOnpremise = process.env.NEXT_PUBLIC_IS_ONPREMISE; // not using getEnv() because it's not getting resolved on few browsers while initial rendering
    if (isOnpremise !== undefined && isOnpremise.toLowerCase() === "true") {
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
}
export function getIsRemoteSystem() {
  var isOnpremise = getIsOnpremise();
  return isOnpremise && window.location.hostname !== "localhost";
}
export function getIsPatientDeletionEnabled() {
  try {
    var isPatientDeletionEnabled = getEnv("NEXT_PUBLIC_IS_PATIENT_FILE_DELETION");
    if ((isPatientDeletionEnabled === null || isPatientDeletionEnabled === void 0 ? void 0 : isPatientDeletionEnabled.toLowerCase()) === "true") {
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
}
export var getAllSources = function getAllSources(userInfo) {
  var sources = get(userInfo, ["upload_sources"], []);
  var listSource = sources.map(function (src) {
    return {
      label: src["name"],
      value: src["id"],
      uuid: src["uuid"]
    };
  });
  return listSource;
};
export var getSource = function getSource(userInfo) {
  var sources = get(userInfo, ["upload_sources"], []);
  var listSource = sources.map(function (src) {
    return {
      label: src["name"],
      value: src["id"],
      uuid: src["uuid"]
    };
  });
  var default_workspace = listSource.find(function (item) {
    return item.value === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.default_workspace);
  });
  return default_workspace !== null && default_workspace !== void 0 ? default_workspace : listSource[0];
};
export var getTimeDifference = function getTimeDifference() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  var timeDifference = differenceInMinutes(new Date(), date);
  var formattedDifference;
  if (timeDifference < 60) {
    formattedDifference = "".concat(timeDifference, "m");
  } else {
    var hours = Math.floor(timeDifference / 60);
    var minutes = timeDifference % 60;
    if (hours < 24) {
      formattedDifference = "".concat(hours, "h ").concat(minutes, "m");
    } else {
      var days = Math.floor(timeDifference / 1440);
      var _hours = hours % 24;
      formattedDifference = "".concat(days, "d ").concat(_hours, "h ").concat(minutes, "m");
    }
  }
  return formattedDifference;
};
export var getFormattedRelativeDateTimeDifference = function getFormattedRelativeDateTimeDifference(date) {
  if (date) {
    var formatRelativeLocale = {
      yesterday: "'".concat(t("yesterday_key"), ", ' p"),
      today: "'".concat(t("today_key"), ", ' p"),
      lastWeek: "PP hh:mm a",
      tomorrow: "PP hh:mm a",
      nextWeek: "PP hh:mm a",
      other: "PP hh:mm a"
    };
    var locale = _objectSpread(_objectSpread({}, enUS), {}, {
      formatRelative: function formatRelative(token) {
        return formatRelativeLocale[token];
      }
    });
    var _date = new Date(date);
    return formatRelative(_date, new Date(), {
      locale: locale
    });
  }
};
export var getDateFromDatetime = function getDateFromDatetime(value) {
  var _value = new Date(value);
  return new Date(_value.getFullYear(), _value.getMonth(), _value.getDate(), 0, 0, 0, 0);
};
export var parseAgeInYearsFromDicomAttribute = function parseAgeInYearsFromDicomAttribute(age) {
  if (!isNaN(+age)) {
    return parseInt(age, 10);
  }
  /*
   * If age is of the form 'X1X2...XnM' where X1,2..n are digits
   * and M is one of measures = {Y(years), M(months), D(days)}.
   * Get the measure and convert rest of the string into number
   */

  var measure = age.slice(-1);
  var modifiedAge = age.slice(0, -1);
  if (isNaN(+modifiedAge)) {
    return 0;
  }
  switch (measure) {
    case "Y":
      return parseInt(modifiedAge, 10);
    case "M":
      return Math.floor(parseInt(modifiedAge, 10) / 12);
    case "W":
      return Math.floor(parseInt(modifiedAge, 10) / 52);
    case "D":
      return Math.floor(parseInt(modifiedAge, 10) / 365);
    default:
      return parseInt(age, 10);
  }
};
export var getMetabaseURL = function getMetabaseURL() {
  var _window3;
  var isOnpremise = getIsOnpremise();
  if (typeof window === "undefined") {
    return getEnv("NEXT_PUBLIC_API_URL");
  }
  if (!isOnpremise) {
    return getEnv("NEXT_PUBLIC_API_URL");
  }
  var hostname = (_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.location.hostname;
  return "http://".concat(hostname, ":").concat(getEnv("NEXT_PUBLIC_ONPREMISE_METABASE_PORT"));
};
export var getMWLURL = function getMWLURL() {
  var _window4;
  var isOnpremise = getIsOnpremise();
  if (typeof window === "undefined") {
    return getEnv("NEXT_PUBLIC_API_URL");
  }
  if (!isOnpremise) {
    return getEnv("NEXT_PUBLIC_API_URL");
  }
  var hostname = (_window4 = window) === null || _window4 === void 0 ? void 0 : _window4.location.hostname;
  return "http://".concat(hostname, ":").concat(getEnv("NEXT_PUBLIC_ONPREMISE_MWL_PORT"));
};
export var getTrimmedWorkspaceId = function getTrimmedWorkspaceId(id) {
  return id && id.slice(-8);
};
export var getAppLogo = function getAppLogo() {
  var isOnpremise = getIsOnpremise();
  // eslint-disable-next-line react-hooks/rules-of-hooks
  var isqTrack = Store.useState(function (store) {
    return store.isqTrack;
  });
  if (isOnpremise || isqTrack) {
    return getEnv("NEXT_PUBLIC_APP_LOGO") || "/assets/images/qTrackLogo.svg";
  }
  return "/assets/images/qureLogo.svg";
};
export var hasSiteKeyword = function hasSiteKeyword() {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  var isqTrack = Store.useState(function (store) {
    return store.isqTrack;
  });
  return getEnv("NEXT_PUBLIC_HAS_SITES_KEYWORD") === "true" || isqTrack;
};
export var trackError = function trackError(errorMessage, url, scope, additionalInfo) {
  var error = new Error(errorMessage);
  datadogRum.addError(error, _objectSpread({
    scope: scope,
    url: url
  }, additionalInfo));
};
export var urlify = function urlify(text) {
  if (text) {
    var urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.replace(urlRegex, '<a class="underline !text-chat-7" href="$1" target="_blank">$1</a>');
  } else {
    return "";
  }
};
export var formatDate = function formatDate(dateString) {
  var year = Number(dateString.substring(0, 4));
  var month = Number(dateString.substring(4, 6));
  var day = Number(dateString.substring(6, 8));
  var date = new Date(year, month - 1, day);
  return format(date, "dd MMM yyyy");
};
export var getUserName = function getUserName(user) {
  return "".concat(user === null || user === void 0 ? void 0 : user.name);
};
export function extractWorkspaceToken(url) {
  try {
    var urlObj = new URL(url);
    return urlObj.searchParams.get("workspace-token");
  } catch (error) {
    console.error("Invalid URL:", error);
    return null;
  }
}